import { css } from 'styled-components';

export const textInputs = {
    roundedCornersInputs: {
        height: '40px',
        lineHeight: '30px',
        borderRadius: '3px',
    },
    squaredinputs: {
        height: '48px',
        lineHeight: '30px',
        borderRadius: '0',
    },
};

export default { ...textInputs };

export type InputType = keyof typeof textInputs;

export const widgetStyle = (key: InputType) => css`
    height: ${({ theme }) => theme[key].height};
    border-radius: ${({ theme }) => theme[key].borderRadius};
    line-height: ${({ theme }) => theme[key].lineHeight};
`;
